jQuery(document).ready(function ($) {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('float_active');
    } else {
      $('body').removeClass('float_active');
    }
  });

  $(document).on('click', '#menu_trigger', function (event) {
    event.preventDefault();

    if ($('body').hasClass('menu_open')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
  });

  //#mobile_menu_overlay
  $(document).on('click', '#mobile_menu_overlay', function (event) {
    event.preventDefault();
    $('body').removeClass('menu_open');
  });

  $('.smooth_scroll').click(function (event) {
    event.preventDefault();
    var margintop = $(this).data('mtop') ? $(this).data('mtop') : 100;

    if ($(this.hash).length > 0) {
      $('html,body').animate({ scrollTop: $(this.hash).offset().top - margintop }, 1200);
    }
  });

  //PARALLAX IMAGE
  var scrolled = $(window).scrollTop(),
    ww = $(window).outerWidth();

  $('[data-parallax-bg]').each(function (i, e) {
    var image =
      ww > 992
        ? $(this).data('parallax-bg')
        : $(this).data('parallax-bg-mobile')
        ? $(this).data('parallax-bg-mobile')
        : $(this).data('parallax-bg');
    var factor = $(this).data('parallax-factor') ? $(this).data('parallax-factor') : 1.5;
    var heightFractor = $(this).data('height-factor') ? $(this).data('height-factor') : '130%';

    $(this).css('overflow', 'hidden');

    var initY = $(this).offset().top;
    var height = $(this).height();
    var diff = scrolled - initY;
    var ratio = Math.round((diff / height) * 100);

    var div = $('<div>', {
      class: 'parallax_background_inner',
      css: {
        position: 'absolute',
        top: parseInt(ratio * factor),
        left: 0,
        width: '100%',
        height: heightFractor,
        'background-image': 'url(' + image + ')',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'z-index': -1,
      },
    });

    $(this).append(div);
  });

  function isInViewport(node) {
    var rect = node.getBoundingClientRect();

    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  $(window).on('scroll', function () {
    var scrolled = $(window).scrollTop();

    $('[data-parallax-bg]').each(function (i, e) {
      var viewPortParent = $(this).data('viewport') ? $(this).data('viewport') : this;
      var initY = $(this).offset().top;
      var height = $(this).height();
      var factor = $(this).data('parallax-factor') ? $(this).data('parallax-factor') : 1.5;

      if (isInViewport(viewPortParent)) {
        var diff = scrolled - initY;
        var ratio = Math.round((diff / height) * 100);
        $(this)
          .children('.parallax_background_inner')
          .css('top', parseInt(ratio * factor) + 'px');
      }
    });
  });

  //accordion_item_header
  $(document).on('click', '.accordion_item_header', function (event) {
    event.preventDefault();
    var accordion = $(this).closest('.accordion_item');

    if ($(accordion).hasClass('open')) {
      $(accordion).removeClass('open');
      $(accordion).find('.accordion_item_content').slideUp();
    } else {
      $('.accordion_item').removeClass('open');
      $('.accordion_item_content').slideUp();
      $(accordion).addClass('open');
      $(accordion).find('.accordion_item_content').slideDown();
    }
  });

  //popup_form
  $(document).on('click', 'a[href^="#popup_"]', function (event) {
    event.preventDefault();
    var popup = $(this).attr('href').replace('#popup_', '');
    $('#' + popup).addClass('active');
  });

  $(document).on('click', '[data-close-popup]', function (event) {
    event.preventDefault();
    var popup = $(this).closest('.popup_form');
    $(popup).removeClass('active');
  });

  //HERO SLIDER
  const hero_slider = new Swiper('.hero_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.hero_slider_nav_prev',
      nextEl: '.hero_slider_nav_next',
    },
  });

  //PRODUCTS CAROUSEL
  const submenu_products_carousel = new Swiper('.submenu_products_carousel', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      prevEl: '.carousel_nav_item_prev',
      nextEl: '.carousel_nav_item_next',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  //testimonials_carousel
  const testimonials_slider = new Swiper('.testimonials_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  //gallery_carousel_swiper
  const gallery_carousel_swiper = new Swiper('.gallery_carousel_swiper', {
    slidesPerView: 2,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
    },
  });

  //htu_tabs_swiper
  const htu_tabs_swiper = new Swiper('.htu_tabs_swiper', {
    slidesPerView: 4,
    spaceBetween: 30,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });

  //data-display-tab
  $(document).on('click', '[data-display-tab]', function () {
    var tab = $(this).data('display-tab');

    $('.how_to_use_product_tab_item').removeClass('active');
    $(this).closest('.how_to_use_product_tab_item').addClass('active');
    $('.how_to_use_product_tab_wrapper').hide();
    $('#tab_' + tab).fadeIn();

    $('html,body').animate({ scrollTop: $('#tab_' + tab).offset().top - 100 }, 1000);
  });

  //video_popup
  $('.video_popup').magnificPopup({
    type: 'iframe',
    iframe: {
      preloader: false,
    },
  });

  //sort_by_trigger
  $(document).on('click', '.sort_by_trigger', function (event) {
    event.preventDefault();
    var dropdown = $(this).next('.sort_by_dropdown');
    if ($(dropdown).hasClass('open')) {
      $(dropdown).removeClass('open');
    } else {
      $(dropdown).addClass('open');
    }
  });

  /*** PRODUCT PAGE ***/
  const product_gallery_slider = new Swiper('.product_gallery_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      prevEl: '.slider_nav_prev',
      nextEl: '.slider_nav_next',
    },
  });

  //[data-gallery-thumb]
  $(document).on('click', '[data-gallery-thumb]', function () {
    var index = $(this).data('gallery-thumb');
    product_gallery_slider.slideTo(index);
  });

  // Initialize product gallery
  function initializeProductGallery() {
    if ($('.product-gallery-variant').length) {
      // Initialize Swiper for each variant gallery
      $('.product-gallery-variant').each(function () {
        const galleryId = $(this).attr('id');
        const slider = new Swiper(`#${galleryId} .product_gallery_slider`, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            prevEl: `#${galleryId} .slider_nav_prev`,
            nextEl: `#${galleryId} .slider_nav_next`,
          },
        });

        // Handle thumbnail clicks
        $(`#${galleryId} [data-gallery-thumb]`).on('click', function () {
          const index = $(this).data('gallery-thumb');
          slider.slideTo(index);
        });
      });
    }
  }

  // Call initialization when document is ready
  $(document).ready(function () {
    initializeProductGallery();
  });

  //[data-radio-variant]
  $(document).on('click', '[data-radio-variant]', function () {
    // Get all selected options
    const selectedOptions = [];
    const optionInputs = document.querySelectorAll('input[type="radio"]:checked');
    const variantName = $(this).data('variant-name');

    optionInputs.forEach((input) => {
      selectedOptions.push(input.value);
    });

    // Find the variant that matches all selected options
    const variant = product_variations.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (variant) {
      // Remove active class from all galleries
      $('.product-gallery-variant').removeClass('active');

      console.log(`#gallery-${variantName}`);

      // Add active class to selected variant gallery
      $(`#gallery-${variantName}`).addClass('active');

      $('#product-variant-id').val(variant.id);
      $('#product-quantity').val(1);

      // Format price to USD currency
      const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(variant.price / 100);

      // Update price in .regular_price element
      document.querySelector('.regular_price').textContent = formattedPrice + ' USD';
    }
  });

  //[data-checkbox-variant]
  $(document).on('click', '[data-checkbox-variant]', function () {
    // Get all selected variants
    const selectedVariants = [];
    const optionInputs = document.querySelectorAll('input[type="checkbox"]:checked');
    const sellingPlan = $('.appstle_select').val();

    console.log('🔍 Checkbox variant clicked, total checked:', optionInputs.length);

    optionInputs.forEach((input) => {
      const variantId = input.getAttribute('data-variant-id');
      if (variantId) {
        selectedVariants.push({
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlan,
        });
        console.log('✅ Added variant to selection:', variantId);
      }
    });

    // Update hidden field with selected variants
    $('#selected-variants').val(JSON.stringify(selectedVariants));

    // Update selected items counter
    const selectedCount = selectedVariants.length;
    $('.selected-variants-count').text(selectedCount > 0 ? `(${selectedCount} selected)` : '');

    console.log('📊 Total selected variants:', selectedCount, selectedVariants);

    if (selectedCount > 0) {
      $('[data-add-sample-product]').removeClass('inactive');
      console.log('🟢 Sample request button activated');
    } else {
      $('[data-add-sample-product]').addClass('inactive');
      console.log('🔴 Sample request button deactivated');
    }
  });

  //data-add-sample-product
  $(document).on('click', '[data-add-sample-product]', function (event) {
    event.preventDefault();
    $('#npi_verification_lightbox').addClass('active');
  });

  // Handle practice type checkbox changes in static modal
  $(document).on('change', 'input[name="practice_type"]', function() {
    const selectedCount = $('input[name="practice_type"]:checked').length;
    const errorDiv = document.getElementById('practice-type-error-static');
    
    if (errorDiv) {
      if (selectedCount > 0) {
        errorDiv.style.display = 'none';
      } else {
        errorDiv.style.display = 'block';
      }
    }
  });

  $(document).on('click', '.close_lightbox', function (event) {
    event.preventDefault();
    $('#npi_verification_lightbox').removeClass('active');
  });

  //npi_verification_form
  $(document).on('submit', '#npi_verification_form', function (event) {
    event.preventDefault();

    var npi_number = $('#npi_number').val();
    var practice_type = [];
    $('input[name="practice_type"]:checked').each(function () {
      practice_type.push($(this).val());
    });
    var practice_name = $('#practice_name').val();

    // Basic format validation only - real validation via CMS API
    if (!/^\d{10}$/.test(npi_number)) {
      alert('Please enter a valid 10-digit NPI number');
      return;
    }

    if (practice_type.length === 0) {
      // Show error message in static modal
      const errorDiv = document.getElementById('practice-type-error-static');
      if (errorDiv) {
        errorDiv.style.display = 'block';
      }
      alert('Please select at least one practice type');
      return;
    } else {
      // Hide error message if at least one is selected
      const errorDiv = document.getElementById('practice-type-error-static');
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }
    }

    if (!practice_name) {
      alert('Please enter your practice name');
      return;
    }

    // Show loading state
    $(this).find('button[type="submit"]').prop('disabled', true).text('Verifying...');

    // First, check if NPI is already used in a subscription
    fetch('https://api.icepick.co/npiregistry/check-subscription.php?npi=' + npi_number, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.isAlreadyUsed) {
          // Show the "already used" message
          $('#npi_already_used').show();
          // Reset button state
          $('#npi_verification_form').find('button[type="submit"]').prop('disabled', false).text('Submit');
        } else {
          // NPI is not already used, proceed with verification
          verifyNPIAndAddToCart(npi_number, practice_type.join(', '), practice_name);
        }
      })
      .catch((error) => {
        console.error('Error checking subscription status:', error);
        // Mostrar un mensaje de error más específico al usuario
        alert('Error checking NPI status. Please try again or contact support.');
        // Restablecer el estado del botón
        $('#npi_verification_form').find('button[type="submit"]').prop('disabled', false).text('Submit');
      });
  });

  // Function to verify NPI and add to cart
  function verifyNPIAndAddToCart(npi_number, practice_type, practice_name) {
    // Call our PHP proxy endpoint
    fetch('https://api.icepick.co/npiregistry/verify-npi.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        npi: npi_number,
        practice_type: practice_type,
        practice_name: practice_name,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (data.result_count > 0 && data.results && data.results.length > 0) {
          // NPI is valid - close lightbox and proceed with adding sample product
          $('#npi_verification_lightbox').removeClass('active');

          // Get the selected variants
          const selectedVariants = JSON.parse($('#selected-variants').val() || '[]');
          console.log('Selected variants:', selectedVariants);

          // Get shared product information
          const productTitle = document.querySelector('.product-title, h1.product__title, .product-name, [data-product-title]')?.textContent?.trim() || 'Sample Product';
          
          // Process each selected variant for sample cart
          selectedVariants.forEach((variant) => {
            // Get variant-specific data
            const variantData = getVariantSpecificData(variant.id);
            
            // Create sample product data with all NPI information
            const sampleProduct = {
              id: variant.id,
              variant_id: variant.id,
              title: productTitle,
              variant_title: variantData.title,
              image: variantData.image,
              quantity: variant.quantity || 1,
              price: 0, // Samples are free
              // Include all NPI data for each product
              npi_number: npi_number,
              practice_type: practice_type,
              practice_name: practice_name,
              samples_requested: 'Yes',
              verified_provider: 'true',
              selling_plan: variant.selling_plan || null
            };

            console.log('Adding sample product with data:', sampleProduct);

            // Add to sample cart instead of regular cart
            if (window.EoseraSampleCheckout && window.EoseraSampleCheckout.addToSampleCart) {
              window.EoseraSampleCheckout.addToSampleCart(sampleProduct);
            } else {
              console.error('EoseraSampleCheckout not available');
            }
          });

          // Check URL for selling_plan parameter before redirect
          const urlParams = new URLSearchParams(window.location.search);
          const sellingPlanId = urlParams.get('selling_plan');
          
          // Handle subscription data based on URL parameter
          if (sellingPlanId && sellingPlanId !== '') {
            // URL has selling_plan parameter - save subscription data
            const subscriptionData = {
              selling_plan_id: sellingPlanId,
              is_subscription: true,
              frequency_name: getSubscriptionFrequencyName(sellingPlanId),
              timestamp: new Date().toISOString(),
              url: window.location.href
            };
            
            try {
              localStorage.setItem('eosera_subscription_plan', JSON.stringify(subscriptionData));
              console.log('💾 Subscription plan saved from URL:', subscriptionData);
            } catch (error) {
              console.error('❌ Failed to save subscription data:', error);
            }
          } else {
            // No selling_plan parameter - clear any existing subscription data (One Time Order)
            try {
              localStorage.removeItem('eosera_subscription_plan');
              console.log('🧹 One Time Order confirmed - cleared subscription data from localStorage');
            } catch (error) {
              console.error('❌ Failed to clear subscription data:', error);
            }
          }

          // Show success message and redirect to checkout after delay
          const successMessage = document.createElement('div');
          successMessage.innerHTML = `
            <div style="
              position: fixed;
              top: 20px;
              right: 20px;
              background: #27ae60;
              color: white;
              padding: 15px 20px;
              border-radius: 8px;
              box-shadow: 0 4px 12px rgba(0,0,0,0.15);
              z-index: 10000;
              animation: slideIn 0.3s ease-out;
            ">
              Sample products added to your cart! Redirecting to checkout...
            </div>
          `;
          document.body.appendChild(successMessage);

          // Redirect to sample checkout after 1.5 seconds
          setTimeout(() => {
            if (successMessage.parentNode) {
              successMessage.parentNode.removeChild(successMessage);
            }
            window.location.href = '/pages/request-samples';
          }, 1500);
        } else {
          alert('Invalid NPI number. Please verify and try again.');
        }
      })
      .catch((error) => {
        console.error('Error verifying NPI:', error);
        alert('Error verifying NPI number. Please try again.');
      })
      .finally(() => {
        // Reset button state
        $('#npi_verification_form').find('button[type="submit"]').prop('disabled', false).text('Submit');
      });
  }

  // Helper function to get variant-specific data
  function getVariantSpecificData(variantId) {
    console.log('🔍 Getting variant-specific data for ID:', variantId);
    
    let variantTitle = '';
    let variantImage = '';

    // Method 1: Get variant title from product_variations global variable
    if (window.product_variations && Array.isArray(window.product_variations)) {
      console.log('📋 product_variations available, searching...');
      const variantData = window.product_variations.find(v => v.id == variantId);
      if (variantData) {
        console.log('✅ Found variant data in product_variations:', variantData);
        variantTitle = variantData.title || variantData.name || '';
        
        // Try to get variant-specific image
        if (variantData.featured_image && variantData.featured_image.src) {
          variantImage = variantData.featured_image.src;
          console.log('🖼️ Found featured image in variant data:', variantImage);
        }
      } else {
        console.log('❌ Variant not found in product_variations');
      }
    } else {
      console.log('❌ product_variations not available');
    }

    // Method 2: Get variant title from selected checkbox
    if (!variantTitle) {
      console.log('🔍 Trying to get variant title from checkbox...');
      const selectedCheckbox = document.querySelector(`input[data-variant-id="${variantId}"]:checked`);
      if (selectedCheckbox) {
        const labelElement = selectedCheckbox.closest('label')?.querySelector('.product_form_input_pill_label');
        if (labelElement) {
          variantTitle = labelElement.textContent.trim();
          console.log('✅ Found variant title from checkbox:', variantTitle);
        }
      }
    }

    // Method 3: Get variant-specific image from gallery
    if (!variantImage && variantTitle) {
      console.log('🔍 Trying to find variant-specific gallery for:', variantTitle);
      // Create handle from variant title (same logic as in main-product.liquid)
      const variantHandle = variantTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      console.log('🏷️ Looking for gallery with handle:', `gallery-${variantHandle}`);
      
      // Try exact handle match first
      let variantGallery = document.querySelector(`#gallery-${variantHandle}`);
      
      // If not found, try alternative patterns
      if (!variantGallery) {
        console.log('🔍 Trying alternative handles...');
        // Try without spaces
        const altHandle = variantTitle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        variantGallery = document.querySelector(`#gallery-${altHandle}`);
        console.log('🏷️ Trying alternative handle:', `gallery-${altHandle}`);
      }
      
      if (variantGallery) {
        console.log('✅ Found variant gallery');
        const galleryImage = variantGallery.querySelector('.product_gallery_image_src, .swiper-slide img, img');
        if (galleryImage) {
          variantImage = galleryImage.src || galleryImage.style.backgroundImage?.match(/url\(["']?(.*?)["']?\)/)?.[1];
          console.log('🖼️ Found image in variant gallery:', variantImage);
        }
      } else {
        console.log('❌ Variant gallery not found');
        
        // Try to find images by matching variant name in filename
        console.log('🔍 Trying to find images by filename pattern...');
        const allImages = document.querySelectorAll('.product_gallery_slider img, .product-gallery img, .product__media img');
        const variantKey = variantTitle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        
        for (const img of allImages) {
          const imgSrc = img.src || '';
          const filename = imgSrc.split('/').pop()?.toLowerCase() || '';
          console.log('🔍 Checking image:', filename, 'for pattern:', variantKey);
          
          if (filename.includes(variantKey) || filename.includes(variantKey.replace('-', '_'))) {
            variantImage = imgSrc;
            console.log('🖼️ Found variant image by filename:', variantImage);
            break;
          }
        }
      }
    }

    // Method 4: Fallback to default product image
    if (!variantImage) {
      console.log('🔍 Using fallback product image...');
      variantImage = document.querySelector('.product_gallery_slider .swiper-slide img, .product-image img, .product__media img, .featured-image img')?.src || '';
      console.log('🖼️ Fallback image:', variantImage || 'None found');
    }

    const result = {
      title: variantTitle || 'Sample Variant',
      image: variantImage
    };
    
    console.log('📦 Final variant data:', result);
    return result;
  }

  // Function to save metadata to subscription
  function saveSubscriptionMetadata(npi_number, practice_type, practice_name, subscription_id) {
    fetch('https://api.icepick.co/npiregistry/save-subscription-metadata.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        npi_number: npi_number,
        practice_type: practice_type,
        practice_name: practice_name,
        subscription_id: subscription_id,
        shop_domain: window.location.hostname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Subscription metadata saved:', data);
      })
      .catch((error) => {
        console.error('Error saving subscription metadata:', error);
      });
  }

  // Subscription plan detection and localStorage sync
  function detectAndSaveSubscriptionPlan() {
    // First check if Appstle widget exists on this page
    const widget = document.querySelector('.appstle_sub_widget');
    if (!widget) {
      console.log('🚫 No Appstle widget found - skipping subscription detection');
      return null;
    }
    
    // Method 1: Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlSellingPlan = urlParams.get('selling_plan');
    
    // Method 2: Check Appstle widget data attribute
    const widgetSellingPlan = widget.getAttribute('data-selected-selling-plan');
    
    // Method 3: Check select dropdown
    const planSelect = document.querySelector('.appstle_sub_widget select.appstle_select');
    const selectSellingPlan = planSelect ? planSelect.value : null;
    
    // Method 4: Check active radio button
    const activeRadio = document.querySelector('.appstle_sub_widget input[name=selling_plan]:checked');
    const radioSellingPlan = activeRadio ? activeRadio.value : null;
    
    // Determine the current selling plan
    let currentSellingPlan = urlSellingPlan || selectSellingPlan || widgetSellingPlan || radioSellingPlan;
    let isSubscription = currentSellingPlan && currentSellingPlan !== '';
    
    console.log('🔍 Subscription Plan Detection:');
    console.log('- URL Selling Plan:', urlSellingPlan);
    console.log('- Widget Data:', widgetSellingPlan);
    console.log('- Select Value:', selectSellingPlan);
    console.log('- Radio Value:', radioSellingPlan);
    console.log('- Final Selling Plan:', currentSellingPlan);
    console.log('- Is Subscription:', isSubscription);
    
    // Handle localStorage based on subscription type
    if (isSubscription) {
      // Save subscription data to localStorage
      const subscriptionData = {
        selling_plan_id: currentSellingPlan,
        is_subscription: isSubscription,
        frequency_name: getSubscriptionFrequencyName(currentSellingPlan),
        timestamp: new Date().toISOString(),
        url: window.location.href
      };
      
      try {
        localStorage.setItem('eosera_subscription_plan', JSON.stringify(subscriptionData));
        console.log('💾 Subscription data saved to localStorage:', subscriptionData);
      } catch (error) {
        console.error('❌ Failed to save subscription data:', error);
      }
      
      return subscriptionData;
    } else {
      // One Time Order selected - clear subscription data from localStorage
      try {
        localStorage.removeItem('eosera_subscription_plan');
        console.log('🧹 One Time Order selected - cleared subscription data from localStorage');
      } catch (error) {
        console.error('❌ Failed to clear subscription data:', error);
      }
      
      // Return default data for One Time Order
      return {
        selling_plan_id: null,
        is_subscription: false,
        frequency_name: 'One-Time Order',
        timestamp: new Date().toISOString(),
        url: window.location.href
      };
    }
  }

  // Get user-friendly subscription frequency name
  function getSubscriptionFrequencyName(sellingPlanId) {
    const frequencyMap = {
      '7060029728': 'Monthly Subscription',
      '7060062496': 'Quarterly Subscription', 
      '7060095264': 'Semiannual Subscription'
    };
    
    return frequencyMap[sellingPlanId] || (sellingPlanId ? 'Subscription' : 'One-Time Order');
  }

  // Monitor URL changes (for selling_plan parameter)
  let currentUrl = window.location.href;
  function monitorUrlChanges() {
    if (currentUrl !== window.location.href) {
      currentUrl = window.location.href;
      console.log('🔄 URL changed, checking for subscription plan...');
      
      // Only detect if widget exists
      if (document.querySelector('.appstle_sub_widget')) {
        detectAndSaveSubscriptionPlan();
      } else {
        console.log('🚫 No widget found - URL monitoring skipped');
      }
    }
  }

  // Set up monitoring
  setInterval(monitorUrlChanges, 1000); // Check every second

  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function () {
    console.log('📻 Appstle Event: SellingPlanSelected');
    if (jQuery('.appstle_sub_widget input[name=selling_plan]:checked').length > 0) {
      console.log('selling plan', jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val());
      
      // Save subscription data when Appstle event fires
      setTimeout(() => {
        detectAndSaveSubscriptionPlan();
      }, 100);
    }
  });

  // Also monitor for direct changes to the widget
  document.addEventListener('change', function(event) {
    if (event.target.matches('.appstle_sub_widget input[name=selling_plan]') ||
        event.target.matches('.appstle_sub_widget select.appstle_select')) {
      console.log('📻 Widget Change Detected');
      setTimeout(() => {
        detectAndSaveSubscriptionPlan();
      }, 100);
    }
  });

  // Initial detection on page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      // Only run initial detection if widget exists
      if (document.querySelector('.appstle_sub_widget')) {
        console.log('🔍 Widget found - running initial subscription detection');
        detectAndSaveSubscriptionPlan();
      } else {
        console.log('🚫 No Appstle widget found - skipping initial detection');
      }
    }, 2000); // Wait for Appstle to load
  });

  //quantity-selector
  $(document).on('change', '.quantity-input', function () {
    var qty = $(this).val();
    $('#product-quantity').val(qty);
  });

  //qty_plus
  $(document).on('click', '.qty_plus', function () {
    var qty = $(this).prev('.quantity-selector'),
      value = parseInt($(qty).val()),
      max = $(qty).attr('max') ? parseInt($(qty).attr('max')) : 10;

    if (value < max) {
      $(qty)
        .val(value + 1)
        .change();
    }
  });

  //qty_minus
  $(document).on('click', '.qty_minus', function () {
    var qty = $(this).next('.quantity-selector'),
      value = parseInt($(qty).val());

    if (value > 1) {
      $(qty)
        .val(value - 1)
        .change();
    }
  });

  //trigger_megamenu
  $(document).on('mouseenter', '.trigger_megamenu', function () {
    $('#merch_submenu').addClass('active');
  });

  $(document).on('mouseleave', '#merch_submenu', function () {
    $('#merch_submenu').removeClass('active');
  });

  // Back to top functionality
  const backToTop = $('.back_to_top');

  $(window).on('scroll', function () {
    const scrollPercent = ($(window).scrollTop() / ($(document).height() - $(window).height())) * 100;

    if ($(window).scrollTop() > 300) {
      backToTop.addClass('visible');
    } else {
      backToTop.removeClass('visible');
    }
  });

  //mobile_menu expand menus
  $(document).on('click', '#mobile_menu .has-submenu > a', function (event) {
    event.preventDefault();

    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next('.expandable_menu').slideUp();
    } else {
      $('#mobile_menu .has-submenu a').removeClass('open');
      $('#mobile_menu .expandable_menu').slideUp();

      $(this).addClass('open');
      $(this).next('.expandable_menu').slideDown();
    }
  });

  function pageProgress() {
    var progressWrap = document.querySelector('.progress_circle');
    if (progressWrap != null) {
      var progressPath = document.querySelector('.progress_circle');
      var pathLength = progressPath.getTotalLength();
      var offset = 50;
      progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
      progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
      progressPath.style.strokeDashoffset = pathLength;
      progressPath.getBoundingClientRect();
      progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
      window.addEventListener('scroll', function (event) {
        var scroll = document.body.scrollTop || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var progress = pathLength - (scroll * pathLength) / height;
        progressPath.style.strokeDashoffset = progress;
        var scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollElementPos >= offset) {
          progressWrap.classList.add('active-progress');
        } else {
          progressWrap.classList.remove('active-progress');
        }
      });
      progressWrap.addEventListener('click', function (e) {
        e.preventDefault();
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      });
    }
  }

  pageProgress();

  //blog_carousel
  const blog_carousel = new Swiper('.blog_carousel', {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });

  //data-show-tab
  $(document).on('click', '[data-show-tab]', function () {
    var tab = $(this).data('show-tab');

    $('.product_tab').removeClass('active');
    $(this).addClass('active');

    $('.product_tabs_content').hide();
    $('#' + tab).show();
  });

  //rotate_text
  $('.rotate_text').each(function () {
    var words = $(this).data('words').split(',');

    $(this).typer({
      strings: words,
      useCursor: true,
    });
  });

  //data-qty
  $(document).on('click', '[data-decrease]', function () {
    var input = $(this).closest('.quantity-input-group').find('.quantity-input');
    var value = parseInt($(input).val());

    if (value > 1) {
      $(input)
        .val(value - 1)
        .change();
    }
  });

  $(document).on('click', '[data-increase]', function () {
    var input = $(this).closest('.quantity-input-group').find('.quantity-input');
    var value = parseInt($(input).val());
    var max = $(input).attr('max') ? parseInt($(input).attr('max')) : 10;

    if (value < max) {
      $(input)
        .val(value + 1)
        .change();
    }
  });

  function selectVariantFromURL() {
    // Check if we are on a product page (looking for specific elements)
    if (!document.querySelector('input[type="radio"][data-radio-variant]')) {
      return;
    }

    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.toString() === '') {
        return;
      }

      urlParams.forEach((value, key) => {
        key = key + '-1';

        // Get all radio buttons
        const radios = document.querySelectorAll('input[type="radio"][data-radio-variant]');

        radios.forEach((radio) => {
          // Clean up the name attribute by removing whitespace and newlines
          const radioName = radio.getAttribute('name').replace(/\s+/g, '');
          const radioValue = radio.value;

          console.log('Comparing:', {
            'cleaned radio name': radioName,
            'radio value': radioValue,
            'url key': key,
            'url value': value,
          });

          if (radioName.toLowerCase() === key.toLowerCase() && radioValue.toLowerCase() === value.toLowerCase()) {
            radio.click();
          }
        });
      });
    } catch (error) {
      console.warn('Error processing variants from URL:', error);
    }
  }

  // Call the function when page loads
  selectVariantFromURL();

  $('.appstle_subscription_amount').text('Free');
  setTimeout(() => {
    $('.appstle_subscription_amount').text('Free');
  }, 500);

  //MOVE AMAZON BUTTON TO THE TOP OF THE PRODUCT FORM
  if($('.product-form').length > 0){
    console.log('Product form found, checking for Amazon button');

    var amazonCheckInterval = setInterval(function() {
      var $amazonButton = $('delivery-promise-wc');

      console.log('Amazon button found:', $amazonButton.length);

      if ($amazonButton.length > 0) {
        $amazonButton.prependTo('.product-form > form');

        clearInterval(amazonCheckInterval);

        $('.product-form').removeClass('loading');
      }else{
        console.log('Amazon button not found, waiting for it to appear');
      }
    }, 100);
  }

  //reviews_carousel - Initialize each carousel independently
  $('.reviews_carousel_wrapper').each(function() {
    const carouselId = $(this).data('carousel-id');
    const carouselSelector = `#reviews_carousel_${carouselId}`;
    const prevSelector = `[data-carousel-target="${carouselId}"].reviews_carousel_nav_prev`;
    const nextSelector = `[data-carousel-target="${carouselId}"].reviews_carousel_nav_next`;
    
    new Swiper(carouselSelector, {
      slidesPerView: 3.8,
      spaceBetween: 20,
      navigation: {
        prevEl: prevSelector,
        nextEl: nextSelector,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3.8,
          spaceBetween: 20,
        },
      },
    });
  });

  // Text truncation functionality
  function initTextTruncation() {
    $('[data-truncate]').each(function() {
      const $container = $(this);
      const $textElement = $container.find('.review_text');
      const $readMoreLink = $container.find('.read_more_link');
      const wordLimit = parseInt($container.data('truncate')) || 25;
      
      const fullText = $textElement.text().trim();
      const words = fullText.split(/\s+/);
      
      if (words.length > wordLimit) {
        const truncatedText = words.slice(0, wordLimit).join(' ');
        const remainingText = words.slice(wordLimit).join(' ');
        
        // Store original text
        $container.data('full-text', fullText);
        $container.data('truncated-text', truncatedText);
        $container.data('remaining-text', remainingText);
        
        // Set truncated text initially
        $textElement.html(truncatedText + '...');
        $readMoreLink.show();
      }
    });
  }

  // Handle Read More / Read Less clicks
  $(document).on('click', '.read_more_link', function(event) {
    event.preventDefault();
    
    const $link = $(this);
    const $container = $link.closest('[data-truncate]');
    const $textElement = $container.find('.review_text');
    
    const fullText = $container.data('full-text');
    const truncatedText = $container.data('truncated-text');
    
    if ($link.text() === 'Read More') {
      $textElement.html(fullText);
      $link.text('Read Less');
    } else {
      $textElement.html(truncatedText + '...');
      $link.text('Read More');
    }
  });

  // Initialize text truncation when document is ready
  initTextTruncation();
});